import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { reportService } from '../services/api';

function Reports() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    try {
      const data = await reportService.getReports(token);
      setReports(data.reports);
    } catch (err) {
      setError('Error loading reports');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>Loading reports...</div>;
  if (error) return <div className="text-red-600">{error}</div>;

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Reports</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {reports.map((report) => (
          <div key={report.id} className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-semibold mb-4">{report.title}</h2>
            <p className="text-gray-600 mb-4">{report.description}</p>
            <div className="flex justify-end">
              <button className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
                View Report
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Reports;